import { createTheme } from "@mui/material";

const Theme1 = createTheme({
  palette: {
    primary: {
      main: "#1c1f43",
    },
    background: {
      white: "#fff",
    },
    text: {
      primary: "#222a94",
      secondary: "#4273d9",
      tertiary: "#85ccef",

      white: "#fff",
      black: "#000",
      dark: "#000",
    },
  },
});

export default Theme1;
